import { almNamespace } from 'src/utils/almNamespace';
import * as storage from '../../lib/storage';
import { AVAILABLE_ONBOARDING_STAGES } from './const';

/**
 * LocalStorage Helper for testing
 * Using 1:
 * alm.onboardings.init(); - to init onboardings in the LS
 * alm.onboardings.BriefEditing.show(); - start onboarding testing
 *
 * Using 2:
 * alm.onboardings.init(); - to init onboardings in the LS
 * alm.onboardings.BriefEditing.hide(); - stop onboarding testing
 */

const ONBOARDING_STAGES_KEY = 'ALM_ONBOARDING';

const readStages = () => {
  try {
    return JSON.parse(storage.readItem(ONBOARDING_STAGES_KEY) || '{}');
  } catch (e) {
    //
  }
  return {};
};

const writeStages = (stages) => {
  try {
    storage.writeItem(ONBOARDING_STAGES_KEY, JSON.stringify(stages));
  } catch (e) {
    //
  }
};

const getActions = (stage) => ({
  show: () => {
    const stages = readStages();
    stages[stage] = true;
    writeStages(stages);
  },
  hide: () => {
    const stages = readStages();
    stages[stage] = false;
    writeStages(stages);
  },
});

almNamespace.add('onboardings', {
  init: () => {
    const stages = AVAILABLE_ONBOARDING_STAGES.reduce((acc, stage) => {
      window.alm.onboardings[stage] = getActions(stage);
      return {
        ...acc,
        [stage]: false,
      };
    }, {});
    writeStages(stages);
  },
  print: () => {
    // eslint-disable-next-line no-console
    console.log('onboardings', window.alm.onboardings);
  },
});

export const isOnboardingTesting = (stage) => {
  const stages = readStages();
  return !!stages[stage];
};
